import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import { ZeeFontMedium, ZeeFontRegular } from 'src/styles/font';
import { flex } from 'src/styles/utils';

import { CustomStyles } from '../buttons/Button';

export const collapisibleTitle = css`
  padding: 15px 0px 15px 16px;
  ${ZeeFontMedium(14, 18)}
  color:${colors.AccentDarkGrayColor};
  cursor: pointer;
  position: relative;
  ${flex('row', 'space-between')};
`;

export const collapisibleContentWrapper = (showContent: boolean) => css`
  transition: max-height 0.8s;
  max-height: ${showContent ? '800px' : '0px'};
  overflow: hidden;
`;

export const collapisibleContentItem = css`
  ${ZeeFontRegular(14, 18)};
  color: ${colors.AccentInfoPopupDescriptionMobileColor};
  padding: 10px 16px 12px;
`;

export const iconStyle = css`
  margin-left: auto;
  width: 22px;
  height: 22px;
`;

export const boxStyle = css`
  border: 1px solid ${colors.Grey88};
  margin-bottom: 16px;
  border-radius: 4px;
`;

export const accordionItemWrapper = css`
  ${flex('row', 'space-between')};
  cursor: pointer;
  border-bottom: 1px solid ${colors.Grey88};
  width: 100%;
`;

export const showMoreStyle = (showMoreIcon: CustomStyles) => css`
  padding: 12px;
  ${showMoreIcon};
  transform: rotate(180deg);
  transition: 0.5s;
`;

export const showLessStyle = (showLessIcon: CustomStyles) => css`
  padding: 12px;
  ${showLessIcon};
  transition: 0.5s;
`;

export const spanStyle = css`
  background: ${colors.AccentScrollBar};
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 8px;
`;
